<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { useAuthStore } from './stores/auth'
import LoadingSpinner from './components/LoadingSpinner.vue';
import AppDialog from '@/components/AppDialog.vue'
import { useDialog } from '@/composables/useDialog'
import { useI18n } from 'vue-i18n'
import { useAppStore } from './stores/app'

const initializing = ref(true)
const authStore = useAuthStore()
const { dialogRef } = useDialog()
const { confirm } = useDialog()
const { t } = useI18n()
const appStore = useAppStore()

async function onNeedRefresh() {
  if (await confirm(t('refresh.title'), t('refresh.body'), t('refresh.button'))) {
    appStore.update()
  }
}

onMounted(async () => {
  await authStore.init()
  initializing.value = false

  if (appStore.needRefresh) {
    onNeedRefresh()
  }
})

watch(() => appStore.needRefresh, (value) => {
  if (value) {
    onNeedRefresh()
  }
})
</script>

<template>
  <template v-if="initializing">
    <v-app full-height>
      <LoadingSpinner />
    </v-app>
  </template>
  <template v-else>
    <RouterView />

    <!-- Dialog component -->
  </template>
  <AppDialog ref="dialogRef" />
</template>

<style scoped>
</style>
